import { Model } from "@interfaces/model.interface";
import { Guid } from "guid-typescript";

export interface Asset extends Model {
	assetTypeId?: number;
	custodianId?: number;
	invoiceLookupId?: Guid;
	maintenanceInterval?: number;
	make: string;
	model: string;
	name: string;
	purchaseAmount: number;
	purchaseDate: Date;
	purchaseLogId?: number;
	requiresMaintenance: boolean;
	serialNumber: string;
	siteId: number;
	warranty: number;
}

export class Asset implements Asset {	
	make = "";
	model = "";
	name = "";
	purchaseAmount = 0.00;
	purchaseDate = new Date;
	serialNumber = "";
	site = 1;
	warranty = 0;

	constructor(data?: Partial<Asset>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}